require('./newsletter');
require('./search-widget');
require('./vehicles-list');
require('./menu');
require('./test-drive-lead');
require('./offer-request-lead');
require('./auto-dealers');
require('./promotion-offer-request-lead');
require('./service-request-lead');
require('./buy-back-lead');
require('./cookies');
require('./corporate-offer-request-lead');
require('./corporate-test-drive-lead');
require('./corporate-service-request-lead');
require('./promotions-widget');
require('./slider');
require('./careers-widget');
require('./leads');
require('./dacia-offers');



// WEBPACK FOOTER //
// ./resources/assets/js/modules/index.js